export default __webpack_public_path__ + "fdd21e2b08f79625d0708c0ac304412a.png";